import React from 'react';
import "./index.less"

const Schedule = (props) => {
    const {active = 7, rangeMax = 10, rangeMin = 1, scaleNum = 10, isScale = true, intervalResult = []} = props;

    const createArray = (n) => {
        return Array.from({ length: n }, (_, i) => i + 1);
    }

    return (
        <>
            <div className="schedule-wrap">
                {
                    createArray(scaleNum).map((item) => {
                        return <div className={`schedule-item ${(item <= rangeMax && item >= rangeMin) && item != active  ? 'active' : item == active ? 'active1' : ''}`} key={`sch${item}`}>
                            <div className="schedule-item-line"></div>
                            {isScale && <div className="schedule-item-text">{item}</div>}
                        </div>
                    })
                }
            </div>
            {intervalResult.length > 0 && (
                <div className='interval-wrap'>
                    {
                        intervalResult.map(item => <span>{item}</span>)
                    }
                </div>
            )}
        </>
    )
};

export default Schedule;